import React from "react";
import { Button, Form, FormGroup, Label, Input , Col, Row } from 'reactstrap';

import NotificationAlert from "react-notification-alert";
import AuthService from "services/auth.service";
import Loader from "react-loader-spinner";





class NewTform extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
        queue:this.props.queue,
        category:this.props.category,
        client:AuthService.getCurrentUser().username,
        department:AuthService.getCurrentUser().department,
        sub:"",
        description:'',
        formsubcats:[],
        loading:false,
        fileData:"",


    };
    this.getsubcats()

  }



  notify = (typee , msg) => {
    var options = {};
    options = {place: 'tc',message: (<div><div> {msg}</div></div>  ),type: typee,icon: "now-ui-icons ui-1_bell-53",autoDismiss: 7,}
    this.refs.notificationAlert.notificationAlert(options);
  }







componentWillUnmount(){

  this.setState( {
    sub:'',
    description:'',
    formsubcats:[],

});
  
}



//********************************************* */









handleChange = (e) =>{ 
  

  let myPromise = new Promise((myResolve, myReject) =>{ 
  
  // The producing code (this may take some time)
  this.setState({[e.target.name]: e.target.value})



      myResolve(e.target.name);
      myReject("Error");
    




  });
  
  myPromise.then(
    (value)  =>{
      if (value === 'sub') {this.getDescs()
    }
    },
    (error)  =>{console.log(error);}
  );
  
  
  

//handleChange = (e) =>{ this.setState({[e.target.name]: e.target.value})


}

  render(){



      const subcats = this.state.formsubcats.map(cat =><option key={cat.refname}>{cat.refname}</option>
        )


    return(
<div>
<NotificationAlert ref="notificationAlert" />

{ this.state.loading ? <Row className="justify-content-center align-items-center" >

  <Loader
          type="Puff"
          color="rgb(101, 153, 57)"
          height={100}
          width={100}
          timeout={60000} //3 secs
        /></Row>:

<Form>

      <FormGroup>
        <Row>



        <Col xs={12} md={12}>

          <Label for="exampleSelect">Sub-Category</Label>
          <Input type="select" name="sub" id="sub" className="input" onChange={this.handleChange}  value={this.state.sub} required > 
          <option></option>
          {subcats}            
          </Input>
          </Col>
          </Row>



        </FormGroup>
        <Row>
        <Col xs={12} md={12}>

  <Label>Attachment </Label><span>( <strong> Optional</strong> Max 10 Megabytes)</span>
  <br/><br/>
  <input type="file" name="file" onChange={this.getFile}  />

  <br/><br/>

</Col>
        </Row>

        <Row>



        <Col xs={12} md={12}>

        <FormGroup>
        
          <Label for="exampleText">Description</Label>
          <Input type="textarea"   name="description" id="tktsss" onChange={this.handleChange}  value={this.state.description}/>
          <Button variant="primary" type="submit" disabled={!this.state.description} onClick={this.handleSubmit} >
              Submit
          </Button>

        </FormGroup>
        </Col>
        </Row>
</Form>
}
</div>
    )
  }
}






class NewOtherform extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
        queue:'HelpDesk',
        category:'Other',
        client:AuthService.getCurrentUser().username,
        department:AuthService.getCurrentUser().department,

        sub:"Other",
        description:'',

        loading:false,
        fileData:"",


    };

  }



  notify = (typee , msg) => {
    var options = {};
    options = {place: 'tc',message: (<div><div> {msg}</div></div>  ),type: typee,icon: "now-ui-icons ui-1_bell-53",autoDismiss: 7,}
    this.refs.notificationAlert.notificationAlert(options);
  }








componentWillUnmount(){

  this.setState( {
    sub:'',
    description:'',

});
  
}




//********************************************* */



getFile = (e) => {

  if (e.target.files[0].size < 10485760) {


  this.setState({fileData:e.target.files[0]})

  }

  else {
    
    this.setState({fileData:''})

    
    this.notify('danger' ,'Sorry! Maximum File Size is 10 MB, Please Choose another File');

  }


};











handleChange = (e) =>{ 
  

  let myPromise = new Promise((myResolve, myReject) =>{ 
  
  // The producing code (this may take some time)
  this.setState({[e.target.name]: e.target.value})



      myResolve(e.target.name);
      myReject("Error");
    




  });
  
  myPromise.then(
    (value)  =>{

console.log(value)

    },
    (error)  =>{console.log(error);}
  );
  
  
  

//handleChange = (e) =>{ this.setState({[e.target.name]: e.target.value})


}

  render(){




    return(
<div>
<NotificationAlert ref="notificationAlert" />

{ this.state.loading ? <Row className="justify-content-center align-items-center" >

  <Loader
          type="Puff"
          color="rgb(101, 153, 57)"
          height={100}
          width={100}
          timeout={60000} //3 secs
        /></Row>:

<Form autoComplete="off">

      <FormGroup>

        </FormGroup>
        <Row>
        <Col xs={12} md={12}>

  <Label>Attachment </Label><span>( <strong> Optional</strong> Max 10 Megabytes)</span>
  <br/><br/>
  <input type="file" name="file" onChange={this.getFile} />

  <br/><br/>

</Col>
        </Row>

        <Row>



        <Col xs={12} md={12}>

        <FormGroup>
        
          <Label for="exampleText">Description</Label>
          <Input type="textarea"   name="description" id="tktsss" onChange={this.handleChange}  value={this.state.description}/>
          <Button variant="primary" type="submit" disabled={!this.state.description} onClick={this.handleSubmit} >
              Submit
          </Button>

        </FormGroup>
        </Col>
        </Row>
</Form>
}
</div>
    )
  }
}




class NewSAPform extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
        queue:this.props.queue,
        category:'',
        client:AuthService.getCurrentUser().username,
        department:AuthService.getCurrentUser().department,

        sub:"User Support",
        description:'',
        formcatgs:[],
        formsubcats:[],
        sapreqnum:'',
        loading:false,
        fileData:"",


    };
    this.getcatgs()

  }



  notify = (typee , msg) => {
    var options = {};
    options = {place: 'tc',message: (<div><div> {msg}</div></div>  ),type: typee,icon: "now-ui-icons ui-1_bell-53",autoDismiss: 7,}
    this.refs.notificationAlert.notificationAlert(options);
  }










  /*getsubcats = () =>{

    let catg = this.state.category
  .then(response => {
    
        this.setState( {
          formsubcats:[],
      });
  
  
         this.setState( {
          formsubcats:response.data,
  
      });
    
        }).then()
      .catch(function (response) {
          //handle error
          console.log(response);
      });
    } */
  




componentWillUnmount(){

  this.setState( {
    sub:'',
    description:'',
    formsubcats:[],

});
  
}



//********************************************* */




getFile = (e) => {

  if (e.target.files[0].size < 10485760) {


  this.setState({fileData:e.target.files[0]})

  }

  else {
    
    this.setState({fileData:''})

    
    this.notify('danger' ,'Sorry! Maximum File Size is 10 MB, Please Choose another File');

  }


};











handleChange = (e) =>{ 
  

  let myPromise = new Promise((myResolve, myReject) =>{ 
  
  // The producing code (this may take some time)
  this.setState({[e.target.name]: e.target.value})



      myResolve(e.target.name);
      myReject("Error");
    




  });
  
  myPromise.then(
    (value)  =>{

   /* if (value === 'category') {this.getsubcats();this.setState({sub: ""})}
   else if (value === 'sub') {this.getDescs() }*/

   console.log('SAP Req has default Sub-Category')
    },
    (error)  =>{console.log(error);}
  );
  
  
  

//handleChange = (e) =>{ this.setState({[e.target.name]: e.target.value})


}

  render(){

    const catgs = this.state.formcatgs.map(cat =><option key={cat.refsub}>{cat.refsub}</option>
      )

      /*const subcats = this.state.formsubcats.map(cat =><option key={cat.refname}>{cat.refname}</option>
        )*/


    return(
<div>
<NotificationAlert ref="notificationAlert" />

{ this.state.loading ? <Row className="justify-content-center align-items-center" >

  <Loader
          type="Puff"
          color="rgb(101, 153, 57)"
          height={100}
          width={100}
          timeout={60000} //3 secs
        /></Row>:

<Form autoComplete="off">

      <FormGroup>
        <Row>

        <Col xs={12} md={12}>

          <Label for="exampleSelect">Category</Label>
          <Input type="select" name="category" id="category" className="input" onChange={this.handleChange}  value={this.state.category} required > 
          <option></option>
          {catgs}            
          </Input>
          </Col>
          </Row>

          <br/> 

          <Row> 



  </Row>
  {this.props.addreqnum ? 

  <Row>


<Col xs={12} md={12}>


  <Label for="requestnum">Request Number( <strong> Optional</strong> Max 10 Characters) </Label>
          <Input type="text" name="sapreqnum" id="sapreqnum" onChange={this.handleChange}  value={this.state.sapreqnum}/>


          </Col>
          
  </Row>:null}

        </FormGroup>
        <Row>
        <Col xs={12} md={12}>

  <Label>Attachment </Label><span>( <strong> Optional</strong> Max 10 Megabytes)</span>
  <br/><br/>
  <input type="file" name="file" onChange={this.getFile} />

  <br/><br/>

</Col>
        </Row>

        <Row>



        <Col xs={12} md={12}>

        <FormGroup>
        
          <Label for="exampleText">Description</Label>
          <Input type="textarea"   name="description" id="tktsss" onChange={this.handleChange}  value={this.state.description}/>
          <Button variant="primary" type="submit" disabled={!this.state.description} onClick={this.handleSubmit} >
              Submit
          </Button>

        </FormGroup>
        </Col>
        </Row>
</Form>
}
</div>
    )
  }
}

















